var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Go to "),_c('a',{attrs:{"href":"https://status.cipherhealth.com/"}},[_vm._v("Status Page")])])}]

export { render, staticRenderFns }